import { OfferErrorContent } from 'Modules/purchase/components/OfferErrorContent/OfferErrorContent'
import { PurchaseLayout } from 'Modules/purchase/layouts/PurchaseLayout/PurchaseLayout'

export const OfferError = () => (
  <PurchaseLayout>
    <OfferErrorContent />
  </PurchaseLayout>
)
